import { useState } from 'react';

import { GetFaq } from 'services/sac/getFaq';
import { PostFormFaleConosco } from 'services/sac/postFormFaleConosco';
import { GetCustomerForRequest } from 'services/sac/getCustomerForRequest';

import { ParamsDataCustomerForRequest, ParamsDataFaq, ParamsBodyFormFaleConosco } from 'utils/typeServices';

const useSac = () => {
    const [dataFaq, setDataFaq] = useState<Array<ParamsDataFaq>>();
    const [dataFormFaleConosco, setDataFormFaleConosco] = useState<boolean>();
    const [dataCustomerForRequest, setDataCustomerForRequest] = useState<ParamsDataCustomerForRequest>();

    const handleClearSac = () => {
        setDataFaq([]);
        setDataFormFaleConosco(undefined);
        setDataCustomerForRequest(undefined);
    }

    const handleGetCustomerForRequest = async ({ token }: { token: string }) => {
        const { data } = await GetCustomerForRequest({ token });

        if (data) {
            setDataCustomerForRequest(data);
        }
    }

    const handleGetFaq = async ({ token }: { token: string }) => {
        const { data } = await GetFaq({ token });

        if (data) {
            setDataFaq(data);
        }
    }

    const handlePostFormFaleConosco = async ({ body }: { body: ParamsBodyFormFaleConosco }) => {
        setDataFormFaleConosco(undefined);
        const { data } = await PostFormFaleConosco({ body });

        if (data) {
            setDataFormFaleConosco(true);
        } else {
            setDataFormFaleConosco(false);
        }
    }

    return { dataFaq, dataCustomerForRequest, dataFormFaleConosco, handleGetCustomerForRequest, handleGetFaq, handlePostFormFaleConosco, handleClearSac };
}

export default useSac;